export const departmentCategory = {
  BUSINESS_CONSULTANT: 1,
  PROJECT_MANAGER: 2,
  ADMINISTRATIVE: 3
}



// WEBPACK FOOTER //
// ./src/constants/departmentCategory.js